import type {
  ModalNewGroup,
  OptionsMessagesConfirmation,
  RecipientGroupsState,
} from "Pages/ImportWizard/model";
import { atom } from "recoil";

export const recipientGroupsState = atom<RecipientGroupsState>({
  key: "importFile_recipientGroupsState",
  default: {
    loading: false,
    status: "initial",
    items: [],
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    orderBy: "AssignmentDate",
    orderDescending: true,
  },
});

export const modalNewGroupState = atom<ModalNewGroup>({
  key: "importFile_modalNewGroupState",
  default: {
    Show: false,
    GroupName: "",
    IsDirty: false,
  },
});

export const messagesConfirmationState = atom<OptionsMessagesConfirmation>({
  key: "importFile_messagesConfirmationState",
  default: {
    options: [],
  },
});
